import React, { ReactNode } from 'react';
import { DatePicker, FormItemProps } from 'antd';
import { RangePickerProps } from 'antd/es/date-picker';
import { JInputWrapper } from '../JInputWrapper';
import { Moment } from 'moment';
import { disabledDate } from '../../JFormCompositor/utils';
import { pickerLocale } from '../../lib/utils/picker-locale';
import {PickerLocale} from "antd/lib/date-picker/generatePicker";

const { RangePicker } = DatePicker;

export type JDatePickeraProps = {
    /**
     * Action to update external module
     * @param value
     */
    onChange?: (values: [Moment, Moment], formats: [string, string]) => void;
    /**
     * label
     */
    label?: ReactNode;

    /**
     * name
     */
    name?: string | number | (string | number)[];
    /**
     * Date format
     */
    format?: string;

    /**
     * disabled
     */
    disabled?: boolean;

    /**
     * showTime
     */
    showTime?: boolean;

    /**
     * ant design Form.Item props
     * https://ant.design/components/form/#API
     */
    itemProps?: FormItemProps;

    /**
     * ant design Input props
     * https://ant.design/components/date-picker/#API
     */
    rangePickerProps?: RangePickerProps;

    /**
     * defaultValue
     */
    defaultValue?: any;

    /**
     * Custom picker placeholder
     */
    placeholder?: [string, string]

    /**
     * Disabled min picker date
     */
    minDate?: Date,

    /**
     * Disabled max picker date
     */
    maxDate?: Date,

    /**
     * Locale for Range Picker
     */
    locale?: PickerLocale
};

export const JRangePicker = ({
    label,
    name,
    defaultValue,
    showTime = false,
    format = (showTime ? 'DD/MM/YYYY HH:mm' : 'DD/MM/YYYY'),
    disabled,
    onChange,
    itemProps,
    placeholder,
    rangePickerProps = {},
    locale,
    ...otherProps
}: JDatePickeraProps) => {
    
    const props: RangePickerProps = {
        showTime: showTime && { format: 'HH:mm' },
        disabled: disabled,
        defaultValue: defaultValue,
        disabledDate: (m) => disabledDate(m, otherProps.minDate, otherProps.maxDate),
        format: format,
        placeholder,
        onChange: (values: any, formats: [string, string]) => (onChange ? onChange(values, formats) : '')
    }

    if (label) {
        return (
            <JInputWrapper label={label} name={name} {...itemProps} {...rangePickerProps}>
                <RangePicker {...props}  locale={locale ?? pickerLocale}/>
            </JInputWrapper>
        )
    }
    return (<RangePicker {...props}  {...rangePickerProps} locale={locale ?? pickerLocale}/>);
};
